import { CompanyProfileType } from '@/api/backend/types';
import { Container } from '@/components/container';
import { SubNavContainer } from '@/components/sub-nav-container';
import { TabsList, TabsRoot, TabsTrigger } from '@opaz/ui-components';
import { createFileRoute, Link, Outlet, useLocation, useNavigate } from '@tanstack/react-router';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { PermissionGuard } from '../../../../components/permission-guard';
import { PROFILE_PERMISSION } from '../../../../lib/constants';
import { ProfileContext } from '../route';

export const Route = createFileRoute('/_auth/profile/company/_layout')({
  component: RouteComponent,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: null,
      }),
    };
  },
});

function RouteComponent() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { profile } = useContext(ProfileContext);
  const location = useLocation();
  const activeTab = location.pathname.split('/').pop() as string;
  const companyProfile = profile as CompanyProfileType;

  if (companyProfile.type !== 'COMPANY') {
    navigate({ to: '/profile/investor' });
  }

  return (
    <>
      <SubNavContainer>
        <div className="flex gap-4 items-center">
          <div className="flex flex-col">
            <p className="text-xl md:text-3xl font-bold text-foreground">
              {i18n.language === 'ar' ? companyProfile.nameAr : companyProfile.nameEn}
            </p>
            <p className="text-base md:text-xl text-muted-foreground">{companyProfile.identifier}</p>
          </div>
        </div>
      </SubNavContainer>

      <Container>
        <TabsRoot value={activeTab} variant="toggle" width="full" dir={i18n.dir()}>
          <TabsList className="mb-12 overflow-x-auto">
            <Link className="w-full" to="/profile/company/cr-information">
              <TabsTrigger className="whitespace-nowrap" value="cr-information">
                {t('profile.company.tabs.crInformation.title')}
              </TabsTrigger>
            </Link>

            <Link className="w-full" to="/profile/company/notification-settings">
              <TabsTrigger className="whitespace-nowrap" value="notification-settings">
                {t('profile.company.tabs.notificationSettings.title')}
              </TabsTrigger>
            </Link>

            <PermissionGuard permission={PROFILE_PERMISSION.PMS_REPRESENTATIVES}>
              <Link className="w-full" to="/profile/company/representatives">
                <TabsTrigger className="whitespace-nowrap" value="representatives">
                  {t('profile.company.tabs.representatives.title')}
                </TabsTrigger>
              </Link>
            </PermissionGuard>
          </TabsList>

          <Outlet />
        </TabsRoot>
      </Container>
    </>
  );
}
